import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#0B1E2D] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="/assets/logo/SGASTRAT-Logo.png"
                alt="SGA STRAT"
                className="h-10 w-auto brightness-0 invert"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                }} />

            </Link>
            <p className="font-montserrat font-semibold text-lg mb-2">
              Strategy. Capability. Orchestration.
            </p>
            <p className="font-inter text-sm text-slate-400 leading-relaxed">
              Helping organizations bridge the gap between strategic intent and execution.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-montserrat font-semibold text-sm uppercase tracking-wider mb-6 text-[#4DB848]">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
              { name: 'Proficiency', path: '/proficiency' },
              { name: 'Professional Services', path: '/professional-services' },
              { name: 'Solutions', path: '/solutions' },
              { name: 'Modus Operandi', path: '/modus-operandi' }].
              map((item) =>
              <li key={item.path}>
                  <Link
                  to={item.path}
                  className="font-inter text-sm text-slate-400 hover:text-white transition-colors">

                    {item.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-montserrat font-semibold text-sm uppercase tracking-wider mb-6 text-[#4DB848]">
              Resources
            </h4>
            <ul className="space-y-3">
              {[
              { name: 'Insights', path: '/insights' },
              { name: 'Contact Us', path: '/engage' }].
              map((item) =>
              <li key={item.path}>
                  <Link
                  to={item.path}
                  className="font-inter text-sm text-slate-400 hover:text-white transition-colors">

                    {item.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-montserrat font-semibold text-sm uppercase tracking-wider mb-6 text-[#4DB848]">
              Get in Touch
            </h4>
            <div className="space-y-3 font-inter text-sm text-slate-400">
              <p>Office address: Jasmine Street, Kammanahalli, Bengaluru - 560084, India</p>
              <p>Email: shekhar@sgastrat.com</p>
              <p>Phone: +91 80970 48355</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-inter text-sm text-slate-500">
            &copy; {currentYear} SGA STRAT. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="font-inter text-xs text-slate-500">
              Strategy-Led Transformation Partner
            </span>
          </div>
        </div>
      </div>
    </footer>);

};